export default __webpack_public_path__ + "maps-guides-styles-layers-raster-layer-960-c2ed4e7bc6d32384599db2904e410d70.png";